// otel.js
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';

// Create a provider for tracing data
const provider = new WebTracerProvider();

// Remove trailing '/api' or '/api/' if present
const apiBase = (process.env.REACT_APP_API || '').replace(/\/api\/?$/, '');

const exporter = new OTLPTraceExporter({
  url: `${apiBase}/v1/traces`, // URL of your OpenTelemetry collector
});

// Add the exporter to the provider
provider.addSpanProcessor(new BatchSpanProcessor(exporter));

// Register the provider
provider.register();

// Register auto-instrumentations
registerInstrumentations({
  instrumentations: [
    getWebAutoInstrumentations({
      '@opentelemetry/instrumentation-fetch': {
        // Add fetch instrumentation configuration here
      },
      '@opentelemetry/instrumentation-xml-http-request': {
        // Add XHR instrumentation configuration here
      },
      '@opentelemetry/instrumentation-document-load': {
        // Add document load instrumentation configuration here
      },
      '@opentelemetry/instrumentation-user-interaction': {
        // Add user interaction instrumentation configuration here
      },
    }),
  ],
});

